<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('document')"
      :columns="columns"
      :column_search="true"
      resource_url="/document-sign/document/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <document-modal ref="document_modal" @success="refresh" />
  <log-modal ref="log_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  download,
  success_message,
  format_date,
  error_message,
  format_currency,
} from "@/utils";
import DocumentModal from "./document_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import moment from "moment";

export default {
  name: "DocumentDatatable",
  components: { GenericTable, DocumentModal, LogModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("profile"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.profile ? row.profile.name || "" : "";
          },
        },
        {
          title: v.$t("addressee"),
          data: (row) => {
            if (row.addressee) {
              return `<div class="title is-6"><span class="icon"><i class="fa fa-user"></i></span>${row.addressee.name}</div>
                      <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-at"></i></span>${row.addressee.email}</div>
                      <div class="subtitle is-6"><span class="icon"><i class="fa fa-phone"></i></span>${row.addressee.phone}</div>`;
            } else return "";
          },
        },
        {
          title: v.$t("status"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.translate_status(row.status_code) || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let default_buttons = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view as addressee"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  window.open(`/document-sign/sign/${e.detail.uuid}`, "_blank");
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete document?"),
                    v,
                    () => {
                      del("/document-sign/document", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (row.status_code === "S") {
              default_buttons.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download"),
                icon: "fa fa-download",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("row", row);
                  v.$root.loader(true);
                  download(
                    `/document-sign/document/download?uuid=${e.detail.uuid}`,
                    `${row.addressee.name}_${moment().format(
                      "YYYYMMDDHHmmss"
                    )}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              });
            }

            return generate_datatables_buttons(default_buttons);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    create() {
      let v = this;
      v.$refs.document_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      let statuses = {
        N: v.$t("new"),
        O: v.$t("opened"),
        S: v.$t("signed"),
        R: v.$t("rejected"),
        D: v.$t("dismissed"),
        E: v.$t("expired"),
      };
      return statuses[status_code] || status_code;
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
